import React from "react";
import { ContentSection, ButtonRenderProps, LabeledText } from "sprint-common-web";

import { PurgeEncodeCacheButton, PurgeEncodeCacheButtonProps } from "./PurgeEncodeCacheButton";
import { useEncodeCachingManagerItem } from "./useEncodeCachingManagerItem";

export const EncodeCachingManager: React.FC = () => {
    const { item, isLoading, resetCount } = useEncodeCachingManagerItem();
    const headerButtons: ButtonRenderProps<PurgeEncodeCacheButtonProps> = {
        onSuccess: resetCount,
        render: PurgeEncodeCacheButton
    };

    return (
        <>
            <ContentSection header={"Encode cache"} buttons={[headerButtons]} isLoading={isLoading}>
                <LabeledText label="Count" value={item.count} />
            </ContentSection>
        </>
    );
};
